module.exports = __webpack_public_path__ + "static/img/brand-3.57bb58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/brand-3.png
// module id = IOM/
// module chunks = 2